<template>
  <div id="userAll">
    <div class="classify">
      <div class="left">
        <div>
          <span class="status">状态：</span>
          <span
            @click="setStatusAct(0, null)"
            :class="statusAct === 0 ? 'act' : 'statusList'"
            >全部</span
          >
          <span
            @click="setStatusAct(1, 1)"
            :class="statusAct === 1 ? 'act' : 'statusList'"
            >已发布</span
          >
          <span
            @click="setStatusAct(2, 2)"
            :class="statusAct === 2 ? 'act' : 'statusList'"
            >审核中</span
          >
          <span
            @click="setStatusAct(3, 3)"
            :class="statusAct === 3 ? 'act' : 'statusList'"
            >未通过</span
          >
          <span
            @click="setStatusAct(4, 4)"
            :class="statusAct === 4 ? 'act' : 'statusList'"
            >已下架</span
          >
          <span
            @click="setStatusAct(5, 5)"
            :class="statusAct === 5 ? 'act' : 'statusList'"
            >草稿</span
          >
        </div>
        <div>
          <span class="status">售卖：</span>
          <span
            @click="setSaleType(null)"
            :class="saleType === null ? 'act' : 'statusList'"
            >全部</span
          >
          <span
            @click="setSaleType(0)"
            :class="saleType === 0 ? 'act' : 'statusList'"
            >免费课</span
          >
          <span
            @click="setSaleType(1)"
            :class="saleType === 1 ? 'act' : 'statusList'"
            >付费课</span
          >
        </div>
      </div>
      <div class="right">
        <span class="time">时间：</span>
        <DatePicker
          v-model="dateArr"
          format="yyyy-MM-dd"
          @on-change="handleChange"
          type="daterange"
          placement="bottom-end"
          placeholder="Select date"
          style="width: 220px"
        ></DatePicker>
        <Input
          v-model="search"
          placeholder="请输入标题进行搜索"
          class="searchinput"
        >
          <Icon @click="handleClick" type="ios-search" slot="suffix" />
        </Input>
        <input type="text" style="opacity: 0; width: 0" />
      </div>
    </div>
    <div class="list">
      <div class="box" v-for="item in list" :key="item.articleId">
        <div class="left">
          <div class="listImg">
            <img class="img" :src="$global.imgUrl + item.cover" />
          </div>
          <div class="msg">
            <h3 class="title" v-html="item.title" @click="toDetail(item.auditStatus, item.articleId)"></h3>
            <div class="saleType">
              {{ item.saleType == 0 ? "免费课" : "付费课" }}
            </div>
            <div :class="item.auditStatus | colored" v-if="item.status === 0">
              <span style="margin-right: 10px;">{{ item.auditStatus | type }}</span>
              <span v-if="item.auditStatus == 3"
                >原因：<span class="value1">{{ item.opinion }}</span></span
              >
            </div>
            <div class="pass" v-if="item.status === 2">
              <span style="margin-right: 10px;">已下架</span>
            </div>
          </div>
        </div>
        <div class="right">
          <div class="passTime">
            {{ item.createTime }}
          </div>
          <div class="edit" v-if="item.status !== 2">
            <template v-if="item.auditStatus === 0">
              <span class="black">修改</span>
              <span class="black">删除</span>
            </template>
            <template v-if="item.auditStatus === 3">
              <span class="blue" @click="edit(item.articleId)">修改</span>
              <span class="blue" @click="del(item)">删除</span>
            </template>
            <template v-if="item.auditStatus === 1">
              <span class="blue" @click="edit(item.articleId)">修改</span>
              <span class="blue" @click="del(item)">删除</span>
            </template>
            <template v-if="item.auditStatus === 2">
              <!-- <span class="blue" @click="openDrawer(item.articleId)"
                >详细信息</span
              > -->
              <span class="black">修改</span>
              <!-- <span class="blue">下架</span> -->
              <span class="black">删除</span>
            </template>
          </div>
          <div class="edit" v-else>
            <span class="black">修改</span>
            <span class="blue" @click="del(item)">删除</span>
          </div>
        </div>
      </div>
      <Spin fix v-if="spinShow">
        <Icon type="ios-loading" size="18" class="demo-spin-icon-load"></Icon>
        <div>加载中...</div>
      </Spin>
    </div>
    <Paging
      :total="total"
      :curPage="page"
      :limit="10"
      :showPage="5"
      @changePager="handlePager"
    ></Paging>
    <Drawer :mask-closable="false" width="60" v-model="detailsShow">
      <DrawerDetail v-if="detailsShow" :id="articleId" />
    </Drawer>
  </div>
</template>

<script>
import { mapState } from "vuex";
import mixin from "@/mixins/continuingly";
import Paging from "@/components/paging/index.vue";
import DrawerDetail from "./drawerDetail.vue";

export default {
  name: "all",
  computed: {
    ...mapState(["token"]),
  },
  mixins: [mixin],
  components: { Paging, DrawerDetail },
  data() {
    return {
      dateArr: [null, null],
      search: null,
      status: null,
      saleType: null,
      statusAct: 0,
      spinShow: false,
      list: [],
      page: 1,
      total: 0,
      detailsShow: false,
      articleId: "",
    };
  },
  filters: {
    type: function (num) {
      if (num === 2) {
        return "已发布";
      } else if (num === 0) {
        return "审核中";
      } else if (num === 3) {
        return "未通过";
      } else if (num === 1) {
        return "草稿";
      }
    },
    colored: function (num) {
      if (num === 2) {
        return "send";
      } else if (num === 0) {
        return "ing";
      } else if (num === 3) {
        return "pass";
      } else if (num === 1) {
        return "edit";
      }
    },
  },
  created() {
    this.getList();
  },
  methods: {
    async toDetail(auditStatus, articleId) {
      let routeUrl
      switch (auditStatus) {
        case 2:
          routeUrl = this.$router.resolve({
            path: "/courseDetails",
            query: {
              type: 9,
              id: articleId,
            },
          });
          break;
        default:
          const resp = await this.$apis.userServe.setPreview({
            articleId,
            articleType: 9
          });
          routeUrl = this.$router.resolve({
            path: "/previewCourse",
            query: {
              articleId: resp.data,
            },
          });
          break;
      }
      window.open(routeUrl.href, "_blank");
    },
    // 打开详细信息抽屉
    openDrawer(id) {
      this.detailsShow = true;
      this.articleId = id;
    },
    // 修改进入发布页面
    edit(id) {
      this.$router.push(`/courseForm?id=${id}&title=课程`);
    },
    // 删除
    async del(e) {
      this.$Modal.confirm({
        title: "操作确认",
        content: `<p>是否删除<<span>${e.title}</span>>?删除后无法恢复</p>`,
        onOk: async () => {
          const obj = {
            articleId: e.articleId,
            articleType: 9,
            auditStatus: e.auditStatus,
          };
          console.log(obj);
          const res = await this.$apis.userServe.delId(obj);
          if (res.resultCode === "200") {
            this.$Message.success("删除成功");
            this.getList();
          } else {
            this.$Message.error("删除失败");
          }
        },
        onCancel: () => {
          this.$Message.info("已取消删除操作");
        },
      });
    },
    // 分页
    handlePager(e) {
      this.page = e;
      this.getList();
    },
    // 标题搜索
    handleClick() {
      this.page = 1;
      this.getList();
    },
    // 日期筛选
    handleChange(value) {
      console.log(value);
      this.dateArr = value;
      this.page = 1;
      this.getList();
    },
    // 筛选状态
    setStatusAct(i, status) {
      this.statusAct = i;
      this.status = status;
      this.page = 1;
      this.getList();
    },
    setSaleType(type) {
      this.saleType = type;
      this.page = 1;
      this.getList();
    },
    // 获取列表
    async getList() {
      this.spinShow = true;
      const { data } = await this.$apis.userServe.getCurriculumList({
        pageNo: this.page,
        pageSize: 10,
        status: this.status,
        saleType: this.saleType,
        title: this.search,
        beginTime: this.dateArr[0],
        endTime: this.dateArr[1],
      });
      this.spinShow = false;
      let { total } = data;
      this.total = Number(total);
      this.list = data.list;
    },
  },
};
</script>

<style lang="scss" scoped>
#userAll {
  padding-top: 30px;
  //background: yellow;
  width: 1200px;
  //height: 300px;
  .list {
    position: relative;
    margin-top: 30px;
    min-height: 500px;
    .demo-spin-icon-load {
      animation: ani-demo-spin 1s linear infinite;
    }
    .box {
      display: flex;
      justify-content: space-between;
      margin-bottom: 20px;
      padding: 20px 45px;
      min-height: 160px;
      background: #fff;
      .left {
        display: flex;
        flex: 1;
        overflow: hidden;
        .listImg {
          margin-right: 25px;
          width: 280px;
          height: 160px;
          background: rgb(244, 244, 244);
          .img {
            width: 100%;
            height: 100%;
            object-fit: contain;
          }
        }
        .msg {
          flex: 1;
          display: flex;
          flex-direction: column;
          // justify-content: space-between;
          overflow: hidden;
          .title {
            font-size: 20px;
            color: #333333;
            line-height: 28px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            cursor: pointer;
          }
          .saleType {
            margin: 40px 0;
            width: 60px;
            height: 28px;
            line-height: 28px;
            text-align: center;
            background: #e7ebf9;
            border-radius: 4px;
            font-size: 14px;
            color: #0b35c5;
          }
          .articleStatus {
            font-size: 14px;
            color: #666666;
          }

          .edit {
            color: #ff9415;
          }

          .send {
            color: #10286f;
          }

          .ing {
            color: #8073d2;
          }
          .pass {
            color: #ff0000;
          }

          .down {
            color: #dc727c;
          }
        }
      }

      .right {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        margin-left: 10px;
        text-align: right;
        .time {
          font-size: 12px;
          font-family: "Microsoft YaHei";
          font-weight: 400;
          color: #666666;
          text-align: right;
        }

        .edit {
          text-align: right;
          span {
            margin-left: 25px;
            cursor: pointer;
          }
          span:nth-child(2) {
            width: 140px !important;
          }

          .title {
            margin-bottom: 20px;
            font-size: 14px;
            width: 100px;
            //font-family: Microsoft YaHei;
            font-weight: bold;
            line-height: 24px;
            color: #333333;
            cursor: pointer;

            .blue {
              //height: 24px;
              font-size: 12px;
              line-height: 24px;
              //font-family: Microsoft YaHei;
              font-weight: 400;
              color: #183ed7;
            }

            .black {
              //height: 13px;
              font-size: 12px;
              line-height: 24px;
              //font-family: Microsoft YaHei;
              font-weight: 400;
              color: #999999;
            }
          }

          .blue {
            color: rgba(11, 53, 197, 1);
          }

          .black {
            color: #999999;
          }
        }
      }
    }
  }

  .classify {
    display: flex;
    justify-content: space-between;
    width: 100%;

    .right {
      height: 30px;

      .time {
        //background: yellow;
        line-height: 30px;
        margin-right: 10px;
      }

      .searchinput {
        width: 351px;
        //height: 41px;
        border-radius: 10px;
        margin-left: 33px;
      }
    }

    .left {
      font-size: 14px;
      font-weight: 400;
      color: #333333;
      line-height: 30px;

      .status {
        margin-right: 3px;
      }

      .statusList {
        margin-left: 10px;
        margin-right: 10px;
        cursor: pointer;
      }

      .act {
        margin-left: 10px;
        margin-right: 10px;
        color: #0101f3;
        cursor: pointer;
      }
    }
  }
}
// ::v-deep .ivu-drawer-close {
//   top: 0;
//   right: 0;
//   left: 0;
//   width: 36px;
//   height: 36px;
//   border-radius: 0 0 36px 0;
//   background-color: rgba(55, 55, 55, 0.6);
//   .ivu-icon-ios-close {
//     top: -2px;
//     left: -2px;
//     font-size: 34px;
//     color: #fff;
//   }
// }
</style>
